(() => {
    function hulkapps_fix_shipping_price() {
        const cartTotalEl = document.querySelector('[data-hulkapps-cart-total]');
        const cartMessage = document.querySelector('p.cart__message');
        const limit = parseInt(cartMessage.dataset.limit);

        const callback = (mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') updateShippingStatus(mutation.target.textContent);
            }
        };

        const config = {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: false
        };

        const observer = new MutationObserver(callback);

        observer.observe(cartTotalEl, config);

        function updateShippingStatus(price) {
            const currentTotal = parseFloat(price.replace(/[^0-9.]/g, ''));
            if (currentTotal > limit) {
                cartMessage.classList.add('is-success');
            } else {
                cartMessage.classList.remove('is-success');
                const remaining = limit - currentTotal;
                document.querySelector('[data-left-to-spend]').textContent = window.hulkapps.money_format.replace('{{amount}}', remaining);
            }
        }
    }

    if (document.readyState === 'interactive') {
        hulkapps_fix_shipping_price();
    } else {
        document.addEventListener('DOMContentLoaded', hulkapps_fix_shipping_price);
    }
})()